(function () {
  'use strict';

  window.DGS.GlobalSliderConfig.slideInterval = 10000;
})(jQuery);